window.load3QPlayer = async () => {
    
    if(!document.getElementById('js-3q-player-latest')) {
        const script = document.createElement('script');
        script.src = 'https://player.3qsdn.com/js3q.latest.js';
        script.async = true;
        script.setAttribute('id', 'js-3q-latest');
        document.body.appendChild(script);
    }
    
    return new Promise(resolve => {
        let timeout = null;
        const check = () => {
            if(typeof window.js3q === 'undefined') {
                // check again in 100ms
                timeout = window.setTimeout(() => check(), 100);
                return;
            }
            // clear open timeout
            if(timeout) {
                window.clearTimeout(timeout);
            }
            // resolve promise
            resolve(window.js3q);
        };
        check();
    });
};